module.exports = __webpack_public_path__ + "static/media/checkin.8950194b.png";